export default __webpack_public_path__ + "static/media/notesapp.6a369368.svg";